<template>
   <v-container fluid class="e-min-height pa-0">
    <v-flex xs12>
      <div class="e-bg-middle" ></div>
    </v-flex>
    <HeaderTransparent :diccionario="true" :buscador="true" />
    <v-container fluid py-2>
      <v-layout row wrap class="fill-height">
        <v-flex xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

